import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Use the worker that comes with react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const CustomPDFViewer = ({ blobUrl }) => {
  const [numPages, setNumPages] = useState(null);

  if (!blobUrl) return <p>Loading PDF...</p>;

  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        maxHeight: '80vh',
        overflowY: 'auto',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '12px',
        backgroundColor: '#f8f9fa',
        boxSizing: 'border-box',
      }}
    >
      <Document
        file={{ url: blobUrl }} // Pass blob URL as { url }
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={(error) => console.error('PDF load error:', error)}
        loading={<p>Loading PDF...</p>}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '12px',
          width: '100%',
        }}
      >
        {numPages &&
          Array.from({ length: numPages }, (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={Math.min(800, window.innerWidth - 40)} // Responsive width
              renderTextLayer={true} // optional: renders selectable text
              renderAnnotationLayer={true} // optional: renders annotations
            />
          ))}
      </Document>
    </div>
  );
};

export default CustomPDFViewer;
